<template>
  <ul>
    <li v-for="item in strArray" :key="item.url">
      <p>
        {{ $t(item.text) }}:
        <template v-if="item.key === 'url'">
          <span>{{pathFn(rowData.scopeName,rowData.sceneName)}}</span>
        </template>
        <span v-else-if="!item.isFunc">{{ rowData[item.key] }}</span>
        <span v-else>{{ FuncFn(item.key, rowData[item.key]) }}</span>
      </p>
    </li>
  </ul>
</template>

<script>
export default {
  props: ['rowData', 'typeWay'],
  data () {
    return {
      strArray: [
        {
          text: 'public.belong',
          key: 'url'
        },
        {
          text: 'public.carrier',
          key: 'carrierName',
          isFunc: true
        },
        {
          text: 'device.display_name',
          key: 'name',
          isFunc: false
        },
        {
          text: 'device.display_number',
          key: 'displayCode',
          isFunc: false
        },
        {
          text: 'device.display_type',
          key: 'type',
          isFunc: true
        },
        {
          text: $t('integration.display_status'),
          key: 'status',
          isFunc: true
        },
        {
          text: $t('integration.are_you_configuring'),
          key: 'configStatus',
          isFunc: true
        },
        {
          text: $t('integration.display_creation_time'),
          key: 'createTime',
          isFunc: true
        },
        {
          text: $t('integration.display_deactivation_time'),
          key: 'updateTime',
          isFunc: true
        }
      ]
    }
  },
  mounted () {
    if (this.typeWay === 'stop') {
      // this.strArray.splice(1, 1);
      this.strArray.splice(5, 3)
    }
    if (this.typeWay === 'bind' || this.typeWay === 'unbind') {
      this.strArray.pop()
    }
    if (this.typeWay === 'unbind') {
      this.strArray.splice(1, 1)
    }
    if (this.typeWay === 'unknown') {
      this.strArray = [
        {
          text: 'public.belong',
          key: 'url'
        },
        {
          text: 'device.display_name',
          key: 'name'
        },
        {
          text: 'device.display_number',
          key: 'displayCode',
          isFunc: false
        },
        {
          text: 'device.display_type',
          key: 'type',
          isFunc: true
        },
        {
          text: $t('integration.display_creation_time'),
          key: 'createTime',
          isFunc: true
        }
      ]
    }
  },
  methods: {
    FuncFn (key, value) {
      switch (key) {
        case 'type': {
          return value === 1 ? $t('deviceType.gt_1') : $t('deviceType.gt_2')
        }
        case 'status': {
          return value === 1 ? this.$t('public.online') : this.$t('public.offline')
        }
        case 'configStatus': {
          return value === 0 ? $t('device.wait_config') : value === 1 ? $t('device.configured') : $t('device.configured')
        }
        case 'createTime': {
          return this.$timetransition(value)
        }
        case 'updateTime': {
          return this.$timetransition(value)
        }
        case 'carrierName': {
          return this.carrierFn(value)
        }
        default:
          break
      }
    },
    carrierFn (carrierName) {
      if (!carrierName) return
      const array = carrierName.split(',')
      return array
        .map(item => {
          const newArray = item.split('-')
          return newArray[newArray.length - 1]
        })
        .join(',')
    },
    pathFn (scopePath, sencePath) {
      if (!sencePath) return scopePath
      return scopePath + `-[${sencePath}]`
    }
  }
}
</script>

<style lang="scss" scoped>
ul {
  li {
    line-height: 30px;
  }
}
</style>\
